export default defineNuxtPlugin(() => {
  const COOKIE_NAME = "client_source_referrer";

  const CLICK_ID_PARAMS = [
    "fbclid",
    "igshid",
    "ttclid",
    "gclid",
    "gbraid",
    "wbraid",
    "twclid",
    "sccid",
  ];

  const cookie = useCookie(COOKIE_NAME, {
    path: "/",
    sameSite: "lax",
    maxAge: 60 * 60 * 24 * 30,
  });

  const currentUrl = new URL(window.location.href);
  const hasClickId = CLICK_ID_PARAMS.some((param) =>
    currentUrl.searchParams.has(param)
  );

  if (hasClickId) {
    cookie.value = window.location.href;
    return;
  }

  if (cookie.value) return;

  const referrer = document.referrer;

  if (!referrer) return;

  const referrerHost = new URL(referrer).hostname;

  if (!referrerHost || referrerHost === window.location.hostname) return;

  cookie.value = referrer;
});
